module.exports = __webpack_public_path__ + "img/LandschaftIII.59da8759.jpg";